module.exports = "<div>\r\n  <app-top-bar-component></app-top-bar-component>\r\n  <app-top-menu-component></app-top-menu-component>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/container/views/container.component.html
// module id = ./src/app/modules/container/views/container.component.html
// module chunks = main